module.exports = __webpack_public_path__ + "img/visualizacionPagos.1f99fbf5.svg";